class DocumentDrawing {
  _canvas = null;
  width = 0;
  height = 0;

  // 모바일로부터 전송받은 데이터 변환
  convertFromMobileData = (data) => {
    let minX, minY, maxX, maxY;
    const convertPathData = data.coords.data.map((item, index) => {
      let path;
      const pathArray = item.split(',');
      const pathX = Number(pathArray[0]) * this.width;
      const pathY = Number(pathArray[1]) * this.height;

      minX = minX ? (minX > pathX ? pathX : minX) : pathX;
      minY = minY ? (minY > pathY ? pathY : minY) : pathY;
      maxX = maxX ? (maxX < pathX ? pathX : maxX) : pathX;
      maxY = maxY ? (maxY < pathY ? pathY : maxY) : pathY;

      switch (index) {
        case 0:
          path = ['M', pathX, pathY];
          break;
        case data.coords.data.length - 1:
          path = ['L', pathX, pathY];
          break;
        default:
          path = ['Q', pathX, pathY, pathX, pathY];
          break;
      }
      return path;
    });

    return {
      left: minX - 1.5,
      top: minY - 1.5,
      path: convertPathData,
      pathWidth: maxX - minX,
      pathHeight: maxY - minY,
    };
  };

  // 웹으로부터 전송받은 데이터 변환
  convertFromWebData = (data, _width = null, _height = null) => {
    const width = _width ? _width : this.width;
    const height = _height ? _height : this.height;
    const objects = data.objects.map((object) => ({
      ...object,
      scaleX: object.unitScaleX * width,
      scaleY: object.unitScaleY * height,
      left: object.unitLeft * width,
      top: object.unitTop * height,
      ownerDevice: 'web',
    }));
    return { ...data, objects };
  };

  // 제 3자 쪽에서 처리 가능하도록 데이터 가공
  convertCoordinateData = (data) => {
    let mobilePath = [];
    const resultConvertData = data.map((item) => {
      let result = [];
      const x1 = item[1] / this.width;
      const y1 = item[2] / this.height;
      if (item[0] === 'Q') {
        result = [item[0], x1, y1, item[3] / this.width, item[4] / this.height];
      } else {
        result = [item[0], x1, y1];
      }
      mobilePath.push(`${x1},${y1}`);
      return result;
    });
    return { convertPathFromMobile: mobilePath, convertPathFromWeb: resultConvertData };
  };

  // 기존 데이터와 변경된 데이터, 모바일용 데이터 병합
  extractionObject = (jsonData) => {
    const objects = jsonData.objects.map((item) => {
      const width = this.width;
      const height = this.height;
      const strokeWidthScale = item.strokeWidth / width;
      const unitScaleX = item.scaleX / width;
      const unitScaleY = item.scaleY / height;
      const unitLeft = item.left / width;
      const unitTop = item.top / height;
      const { convertPathFromMobile, convertPathFromWeb } =
        item.type === 'path' ? this.convertCoordinateData(item.path) : item;
      return {
        ...item,
        coordsPath: convertPathFromMobile,
        convertPathFromWeb,
        strokeWidthScale,
        unitScaleX,
        unitScaleY,
        unitLeft,
        unitTop,
      };
    });
    return { ...jsonData, objects };
  };

  // 상대방 모바일로부터 데이터를 받았을 경우 데이터 변환
  setDataFromMobile = (documentDrawingData) => {
    const convertData = documentDrawingData.map((item) => {
      const { coordsPath, stroke: color, strokeWidthScale, type } = item;
      const data = { coords: { data: coordsPath } };
      const { left, top, path, pathWidth, pathHeight } = this.convertFromMobileData(data);
      return {
        angle: 0, backgroundColor: '', clipTo: null, fill: null, fillRule: 'nonzero',
        flipX: false, flipY: false, globalCompositeOperation: 'source-over',
        height: pathHeight, left, opacity: 1, originX: 'left', originY: 'top',
        paintFirst: 'fill', path, scaleX: 1, scaleY: 1, shadow: null,
        skewX: 0, skewY: 0, stroke: color, strokeDashArray: null, strokeDashOffset: 0,
        strokeLineCap: 'round', strokeLineJoin: 'round', strokeMiterLimit: 10,
        strokeWidth: strokeWidthScale * this.width, strokeWidthScale,
        coordsPath, top, transformMatrix: null, type,
        version: '3.2.0', visible: true, width: pathWidth, ownerDevice: 'mobile',
      };
    });
    return { background: 'transparent', version: '3.1.0', objects: [...convertData] };
  };

  // 상대방 PC로부터 데이터를 받았을 경우 데이터 변환
  setDataFromWeb = (drawingData) => this.convertFromWebData(drawingData);

  clear = () => { this._canvas.current.clear(); };

  resize = (objectData) => {
    const resultData = this.convertFromWebData(objectData);
    this._canvas.current.fromJSON(resultData);
  };
}

export default DocumentDrawing;
